import { render } from "./BugReportDialog.vue?vue&type=template&id=15e0b2af&ts=true"
import script from "./BugReportDialog.vue?vue&type=script&lang=ts"
export * from "./BugReportDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__